import * as React from "react";
import { useMappedState } from "redux-react-hook";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text/Text";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import type { IStore } from "src/core/shared/store";
import SupportSearch from "src/modules/support/components/SupportSearch";
import useDrop from "src/core/drops/hooks/useDrop";
import PointOfContactDisplay from "src/modules/support/components/PointOfContactDisplay";
import SupportTicketForm from "src/modules/support/components/SupportTicketForm";

const HelpPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { installedModules, supportSettings } = useMappedState(({ global }: IStore) => ({
    installedModules: global.settings ? global.settings.installedModules : [],
    supportSettings: global.settings && global.settings.supportSettings
  }));

  const [ { drop } ] = useDrop();

  const pointOfContact = React.useMemo(() => {
    if (drop && drop.groupedSettings.point_of_contact) {
      return drop.groupedSettings.point_of_contact.value;
    }

    return null;
  }, [ drop ]);

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        {pointOfContact && (
          <PointOfContactDisplay
            mode="live"
            contact={pointOfContact}
          />
        )}

        {installedModules.includes("support") && supportSettings && supportSettings.supportDocuments &&
          <SupportSearch />}

        {supportSettings && supportSettings.supportTickets.enabled && (
          <FeedbackSectionWrapper>
            <div className="feedback-inner">
              <SupportTicketForm />
            </div>
          </FeedbackSectionWrapper>
        )}
      </MainContentWrapper>
    </Layout>
  );
};

const FeedbackSectionWrapper = styled.div`
  ${() => css`
    .feedback-inner {
      width: 600px;
    }
  `}
`;

export default HelpPage;
